<script>
export default {
  name: "portalPromptModal",
  props: {
    account: {
      required: false,
      type: Object,
      default: null,
    },
    approver: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      id: this.$A.GetUUID(),
      working: false,
      sent: false,
    };
  },
  computed: {
    approverEmail() {
      return _.get(this.approver, "email", "");
    },
    accountName() {
      return _.get(this.account, "name", "");
    },
  },
  methods: {
    dismissKey() {
      return `portal_prompt_dismissed_${_.get(this.account, "publicId", "")}_${this.approverEmail.toLowerCase()}`;
    },
    markDismissed() {
      this.$A.SaveDataCache(this.dismissKey(), "1", 365);
    },
    isDismissed() {
      return this.$A.LoadDataCache(this.dismissKey()) === "1";
    },
    showIfEligible() {
      if (
        !_.get(this.account, "customerPortalEnabled", false) ||
        !_.get(this.account, "publicId", "") ||
        !this.approverEmail ||
        this.isDismissed() ||
        this.$A.PortalService.GetSession(this.account.publicId) !== null
      ) {
        return;
      }
      this.sent = false;
      this.$bvModal.show(this.id);
    },
    sendLink: async function () {
      if (this.working) return;
      this.working = true;
      await this.$A.PortalService.RequestMagicLink(
        this.account.publicId,
        this.approverEmail
      );
      this.working = false;
      this.sent = true;
      this.markDismissed();
    },
    noThanks() {
      this.markDismissed();
      this.$bvModal.hide(this.id);
    },
    close() {
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<template>
  <div id="portal-prompt-modal">
    <b-modal :id="id" size="md" hide-footer hide-header centered>
      <div class="w-100 text-center portal-prompt-body">
        <template v-if="!sent">
          <h4>See all your proofs in one place</h4>
          <p>
            {{ accountName }} has a portal where you can sign in with just your
            email and view every proof waiting on you — no passwords needed.
          </p>
          <button class="portal-prompt-btn portal-prompt-btn-primary" @click="sendLink()">
            <b-spinner v-show="working" small type="grow" variant="light"></b-spinner>
            Email Me A Sign-In Link
          </button>
          <button class="portal-prompt-btn portal-prompt-btn-secondary" @click="noThanks()">
            No Thanks
          </button>
        </template>
        <template v-else>
          <h4>Check your inbox</h4>
          <p>
            We sent a sign-in link to <strong>{{ approverEmail }}</strong
            >. It works once and expires in 15 minutes.
          </p>
          <button class="portal-prompt-btn portal-prompt-btn-primary" @click="close()">
            Done
          </button>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.portal-prompt-body {
  padding: 12px 8px;
}
.portal-prompt-body p {
  color: #6b7280;
  margin: 10px 0 18px;
}
.portal-prompt-btn {
  display: block;
  width: 100%;
  margin-bottom: 8px;
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.portal-prompt-btn-primary {
  background-color: #019255;
  color: #ffffff;
}
.portal-prompt-btn-primary:hover {
  background-color: #0c390e;
  color: #ffffff;
}
.portal-prompt-btn-secondary {
  background-color: #f3f4f6;
  color: #4b5563;
}
.portal-prompt-btn-secondary:hover {
  background-color: #e5e7eb;
  color: #374151;
}
</style>
